import { render, staticRenderFns } from "./ClearanceButton.vue?vue&type=template&id=119e3a6e&scoped=true&"
import script from "./ClearanceButton.vue?vue&type=script&lang=ts&"
export * from "./ClearanceButton.vue?vue&type=script&lang=ts&"
import style0 from "./ClearanceButton.vue?vue&type=style&index=0&id=119e3a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119e3a6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/serveradmin/azuredevopsagent3/_work/14/s/kbs.frontend/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('119e3a6e')) {
      api.createRecord('119e3a6e', component.options)
    } else {
      api.reload('119e3a6e', component.options)
    }
    module.hot.accept("./ClearanceButton.vue?vue&type=template&id=119e3a6e&scoped=true&", function () {
      api.rerender('119e3a6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ClearanceButton.vue"
export default component.exports